export const PUBLICITY_ASSETS_CATEGORY_SLUG = 'publicity-assets';
export const PUBLICITY_ASSETS_CATEGORY_ID = 6376;
